import { SVGProps } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export function RadioUncheckedIcon({ fill = "white", ...props }: IconProps) {
  return <Icon as={RadioUncheckedIconComponent} color="purple.500" boxSize="20px" fill={fill} {...props} />;
}

export function RadioUncheckedIconComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.8" y="0.8" width="18.4" height="18.4" rx="9.2" fill={props.fill} stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}
